import { ApiError } from "@secretaa/sdk";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { createRouter } from "./app/router.tsx";
import { applyTheme } from "./features/account/account-page.tsx";
import i18n from "./i18n/index.ts";
import "./index.css";

try {
  const theme = localStorage.getItem("saa_theme");
  if (theme === "light" || theme === "dark") applyTheme(theme);
} catch {
  // localStorage bị chặn: dùng giao diện theo hệ thống
}
document.documentElement.lang = i18n.language;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: (count, error) => !(error instanceof ApiError && error.status < 500) && count < 2, refetchOnWindowFocus: false },
  },
});

const root = document.getElementById("root");
if (root) {
  createRoot(root).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={createRouter()} />
      </QueryClientProvider>
    </StrictMode>,
  );
}
